import Vue from 'vue'
import VueRouter from 'vue-router' // 移除
// import Home from '../views/Home/Home.vue'
const Home = () => import('../views/Home/Home.vue')
// import Goodlist from '../views/Goodlist/Goodlist.vue'
const Goodlist = () => import('../views/Goodlist/Goodlist.vue')
// import Introduction from '../views/Introduction.vue'
const Introduction = () => import('../views/Introduction.vue')
// import MyOrder from '../views/MyOrder.vue'
const MyOrder = () => import('../views/MyOrder.vue')
// import AboutUs from '../views/Aboutus.vue'
const AboutUs = () => import('../views/Aboutus.vue')
// import Detail from '../views/Detail.vue'
const Detail = () => import('../views/Detail.vue')
// import ShoppingCart from '../views/Shoppingcart'
const ShoppingCart = () => import('../views/Shoppingcart')
// import Login from '../views/Login'
const Login = () => import('../views/Login')
// import Address from '../views/Address'
const Address = () => import('../views/Address')
// import Orderdetails from '../views/Orderdetails'
const Orderdetails = () => import('../views/Orderdetails')
// import Orderlist from '../views/Orderlist'
const Orderlist = () => import('../views/Orderlist')
// import SettlementPage from '../views/SettlementPage'
const SettlementPage = () => import('../views/SettlementPage')
// import Security from '../views/Security'
const Security = () => import('../views/Security')
const PaymentStatus = () => import('../views/PaymentStatus')
Vue.use(VueRouter) // 移除
const routes = [
  {
    path: '/home',
    // name: 'Home',
    component: Home
  },
  {
    path: '/goodlist',
    // name: 'Goodlist',
    component: Goodlist,
    meta: {
      keepAlive: false
    }
  },
  // { path: '/home/newsinfo/:id', component: Newsinfo }
  {
    path: '/paymentResult',
    // name: 'PaymentStatus',
    component: PaymentStatus
  },
  {
    path: '/introduction',
    // name: 'Introduction',
    component: Introduction
  },
  {
    path: '/myorder',
    // name: 'MyOrder',
    component: MyOrder
  },
  {
    path: '/aboutus',
    // name: 'AboutUs',
    component: AboutUs
  },
  {
    path: '/detail/:myid',
    //  name: 'Detail',
    component: Detail
  },
  {
    path: '/shoppingcart',
    //  name: 'ShoppingCart',
    component: ShoppingCart
  },
  {
    path: '/login',
    //  name: 'Login',
    component: Login
  },
  {
    path: '/address',
    //  name: 'Address',
    component: Address
  },
  {
    path: '/orderdetails/:myorder',
    //  name: 'Orderdetails',
    component: Orderdetails
  },
  {
    path: '/orderlist',
    //  name: 'Orderlist',
    component: Orderlist
  },
  {
    path: '/settlementPage',
    name: 'settlementPage',
    component: SettlementPage
  },
  {
    path: '/security',
    // name: 'Security',
    component: Security
  },
  {
    path: '*',
    redirect: '/goodlist'
  }
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }

  // {
  //   path: '/home/navbar',
  //   component: Navbar
  // }

]
const router = new VueRouter({
  mode: 'hash',
  // base: process.env.BASE_URL,
  routes
})

export default router
